<template>
	<core-modal
		name="create-tag-modal"
		class="omapi-modal create-tag-modal"
		:click-to-close="!inProgress"
		:child-refs="$refs"
		header-text="Create Tag"
		@closed="name = ''"
	>
		<modals-content>
			<form @submit.prevent="doCreate">
				<label for="tagName">Enter tag name</label><br />
				<input
					ref="toFocus"
					v-model="name"
					type="text"
					name="tagName"
					class="omapi-input"
					placeholder="My Segment Tag"
					@keydown.esc="name = ''"
				/>
				<br />
				<core-loading-button color="blue" type="primary" :loading="inProgress" button-type="submit">
					Add
				</core-loading-button>
			</form>
		</modals-content>
	</core-modal>
</template>

<script>
import { mapActions } from 'vuex';

export default {
	data() {
		return {
			inProgress: false,
			name: '',
			error: null,
		};
	},
	methods: {
		...mapActions('monsterleads', ['createTag']),
		doCreate() {
			if (this.inProgress) {
				return false;
			}

			this.inProgress = true;
			this.createTag(this.name)
				.then(() => {
					this.$store.commit('campaigns/addAlert', {
						message: 'The tag was created successfully.',
						closes: true,
						type: 'success',
					});
				})
				.catch(() => {})
				.finally(() => {
					this.inProgress = false;
					this.$modal.hide('create-tag-modal');
				});
		},
	},
};
</script>
